
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28690',
  depVersions: {
  "payments-ui-app": "static-1.28690",
  "bend-plugin-arboretum": "static-1.2015",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "crm_data": "static-4.93186",
  "data-fetching-client": "static-1.10107",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8737",
  "foundations-components-legacy": "static-1.1762",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6060",
  "hs-test-utils": "static-1.8505",
  "hub-http": "static-1.6676",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11956",
  "I18n": "static-7.1706",
  "jasmine-runner": "static-1.6920",
  "quartz": "static-1.7646",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5653",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6093",
  "UIComponents": "static-3.8902",
  "usage-tracker-public": "static-1.7601",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38037",
  "payments-checkout-lib": "static-1.613",
  "cssUtils": "static-1.1091",
  "customer-data-objects": "static-1.8168",
  "FireAlarmUi": "static-1.4856",
  "foundations-assets": "static-1.5354",
  "foundations-theming": "static-1.4956",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12263",
  "icons": "static-2.701",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3354",
  "property-translator": "static-1.5847",
  "quartz-config": "static-1.1424",
  "quartz-core": "static-1.6865",
  "quartz-i18n": "static-1.1321",
  "quartz-routing": "static-1.1076",
  "quartz-tracking": "static-1.1025",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17204",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10838",
  "rpc-client-utils": "static-1.5139",
  "sanitize-text": "static-1.8627",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.517",
  "superstore": "static-1.5226",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11615",
  "ui-images": "static-2.1275",
  "usage-tracker-core": "static-1.7640",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3923",
  "quartz-webpack": "static-1.3870",
  "bend-plugin-quartz-routing": "static-1.724",
  "bender-build-tools": "static-1.3556",
  "crm_universal": "static-1.22715",
  "customer-data-email": "static-1.18627",
  "customer-data-ui-utilities": "static-1.10303",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8389",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8231",
  "quick-fetch": "static-1.4228",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5006",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2672",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9892",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.101",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3065",
  "ui-fonts": "static-1.1218",
  "HeadJS": "static-2.820",
  "hs-test-utils-bend-plugin": "static-1.3616",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.397",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4777",
  "foundations-components-test-utils": "static-1.6220",
  "ui-addon-draggable": "static-3.5218",
  "commerce-billing-lib": "static-1.20477",
  "commerce-shared-components-lib": "static-1.19551",
  "commerce-tools-ui-lib": "static-1.11307",
  "crm-message-bus": "static-1.44083",
  "customer-data-objects-ui-components": "static-1.13501",
  "customer-data-properties": "static-1.53004",
  "growth-payments-core": "static-1.26487",
  "ui-addon-iframeable": "static-1.9542",
  "usage-tracker": "static-1.7790",
  "usage-tracker-container": "static-1.7780",
  "sassPrefix": "static-1.356",
  "inbound-db-properties-service-client": "static-1.4149",
  "foundations-theming-base": "static-1.3941",
  "bend-plugin-foundations-theming": "static-1.3439",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.259",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "mobile-manifest-mixins": "static-1.603",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.634",
  "quartz-auth": "static-1.1321",
  "quartz-head": "static-1.1311",
  "quartz-test": "static-1.1321",
  "trellis-components": "static-1.3084",
  "usage-tracker-session-replay": "static-1.5476",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.169",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.549",
  "chirp-fetch": "static-1.2372",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4942",
  "FormUrlGenerator": "static-2.5184",
  "sequences-lib": "static-1.8758",
  "apollo-link-hub-http": "static-2.5055",
  "FileManagerCore": "static-1.40320",
  "FileManagerLib": "static-1.40461",
  "hubspot-apollo-client": "static-1.5348",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.726",
  "timezone-utils": "static-2.5700",
  "ui-gdpr-components": "static-1.10655",
  "react-dnd-compat": "static-1.5079",
  "stylex-utils": "static-1.173",
  "trellis-theming": "static-1.1465",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2954",
  "hs-resources": "static-1.664",
  "pulse": "static-1.1113",
  "utility-belt": "static-1.3004",
  "zustand": "static-1.88",
  "batch-promise": "static-1.2014",
  "customer-data-associations": "static-1.7806",
  "customer-data-property-utils": "static-1.8516",
  "customer-data-tracking": "static-1.7340",
  "framework-data-schema-resolvers": "static-1.7361",
  "framework-data-table": "static-2.12829",
  "object-builder-ui-client": "static-1.50025",
  "payments-enrollment-embed-lib": "static-1.24178",
  "stripe-embedded-components": "static-1.8232",
  "ui-addon-opt": "static-4.8869",
  "ai-components-ui-library": "static-1.10004",
  "customer-data-rte": "static-1.33889",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24821",
  "growth-onboarding-confetti": "static-1.3529",
  "growth-onboarding-empty-states": "static-1.6519",
  "hubspot-prosemirror": "static-1.19264",
  "InboxConnectUtils": "static-4.15830",
  "payment-link-components": "static-1.24440",
  "payments-post-enroll-local-storage-lib": "static-1.5572",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39154",
  "react-colorpicker": "static-2.10677",
  "ui-addon-upgrades": "static-9.18544",
  "ui-addon-video-player": "static-1.9093",
  "user-context": "static-1.5521",
  "restore-request-side-panel-lib": "static-1.2019",
  "atom": "static-1.5543",
  "reference-resolvers": "static-1.8649",
  "calling-global-api": "static-1.66164",
  "calling-internal-common": "static-1.31796",
  "calling-lifecycle-internal": "static-1.67546",
  "calling-lifecycle-messages": "static-1.59839",
  "commerce-products-lib": "static-1.10887",
  "conditional-properties-service-client": "static-1.4110",
  "crm-index-visualization-core": "static-1.4747",
  "crm-links": "static-1.6776",
  "crm-pipelines-api-client-types": "static-1.4440",
  "customer-data-properties-shared-msw-handlers": "static-1.10214",
  "external-options-client-types": "static-1.4437",
  "formula-editor": "static-1.15001",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3773",
  "inbounddb-objects-service-types": "static-1.4517",
  "meetings-icalendar-utils-lib": "static-1.1104",
  "multi-currency-client-types": "static-1.4005",
  "pipeline-validation-client-types": "static-1.4278",
  "property-value-citations": "static-1.3618",
  "reference-resolvers-lite": "static-1.8575",
  "smart-data-capture-core": "static-1.461",
  "smart-property-lib": "static-1.8630",
  "tiered-pricing": "static-1.2237",
  "topics-actions-lib": "static-1.650",
  "trellis-ext-i18n": "static-1.1374",
  "trial-components-library": "static-1.14364",
  "ui-addon-form-validation": "static-1.11346",
  "laboratory-lib": "static-3.7617",
  "onboarding-scopes": "static-1.6921",
  "seat-types-lib": "static-1.1033",
  "magpie-lib": "static-1.5904",
  "navigation-messaging": "static-1.8478",
  "ts-schema": "static-1.4391",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10887",
  "hubspotter-http-shared-msw-handlers": "static-1.10885",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8615",
  "audio-components": "static-1.6558",
  "breeze-artifacts-sdk": "static-1.911",
  "ContentUtils": "static-1.69455",
  "copilot-toolkit": "static-1.12130",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30048",
  "FileManagerImages": "static-1.37972",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4610",
  "ui-universal-auth": "static-1.9719",
  "urlinator": "static-1.4984",
  "video-components": "static-1.14418",
  "video-data-lib": "static-1.36074",
  "video-embed": "static-1.36908",
  "hubspot-apollo-cache": "static-1.807",
  "trellis-migration-context": "static-1.47",
  "event-emitter": "static-1.1431",
  "fdsr-migration-layer": "static-1.480",
  "framework-builder-read-service-client": "static-1.4332",
  "bend-plugin-pulse": "static-1.616",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7266",
  "persist-promise": "static-1.4171",
  "customer-data-reference-ui-components": "static-1.13639",
  "reporting-data": "static-1.69321",
  "tasks-actions-lib": "static-1.420",
  "purchase-motions-components": "static-1.6620",
  "growth-onboarding-feedback-components": "static-1.7051",
  "growth-onboarding-reliability": "static-1.5551",
  "marketplace-ui-apps-core": "static-1.19567",
  "onboarding-tours": "static-1.17389",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23821",
  "content-assistance-lib": "static-1.8411",
  "draft-content-plugins": "static-1.29142",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22344",
  "rich-text-lib": "static-1.20539",
  "breeze-engine-lib": "static-1.2132",
  "poll-commands": "static-1.3944",
  "video-components-external": "static-1.12416",
  "trellis-story-utils": "static-1.4967",
  "ui-addon-react-router-dom": "static-1.9996",
  "content-media-capture": "static-1.5774",
  "knowledge-content-types": "static-1.8756",
  "ui-addon-emoji-picker": "static-1.10333",
  "ui-business-units-lib": "static-1.9566",
  "ui-shepherd-react": "static-3.10745",
  "hub-http-contrib": "static-1.3499",
  "ui-addon-sales-email": "static-1.5671",
  "commerce-tours-lib": "static-1.6851",
  "getting-started-shared-tasks": "static-1.19548",
  "sales-checkout-service-client": "static-1.3991",
  "merchandise-lib": "static-1.284",
  "getting-started-shared-tasks-store": "static-1.18666",
  "onboarding-tours-utils": "static-1.1456",
  "calling-error-reporting": "static-1.31803",
  "shared-worker-versioning": "static-1.11509",
  "calling-usage-tracker": "static-1.7006",
  "conversations-skeleton-state": "static-1.7607",
  "voice-sms-access-library": "static-1.2421",
  "commerce-permissions": "static-1.1255",
  "products-iframe-lib": "static-1.8895",
  "products-ui-components-shared-msw-handlers": "static-1.11269",
  "crm-index-associations-lib": "static-1.6917",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10970",
  "sales-views-client-types": "static-1.4724",
  "location-customization-utils-lib": "static-1.10400",
  "bark-lib": "static-1.16999",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6359",
  "react-codemirror": "static-1.11109",
  "data-agent-kit": "static-1.900",
  "data-agent-test-utils": "static-1.444",
  "data-agent-utils": "static-1.913",
  "data-token-picker": "static-1.17121",
  "fsm": "static-1.4227",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7278",
  "react-tinymce": "static-1.56256",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11033",
  "tinymce-config": "static-2.55382",
  "tinymce-plugins": "static-1.58496",
  "embedded-academy-lib": "static-1.15989",
  "hubs-service-types": "static-1.1735",
  "navigation-components": "static-1.19151",
  "nest": "static-1.704",
  "nudge-client-utils": "static-1.3407",
  "purchase-motions-api": "static-1.6623",
  "signup-constants": "static-1.19930",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5364",
  "reactive-lib": "static-1.1191",
  "simple-logging-lib": "static-1.3520",
  "nav-meta": "static-1.30788",
  "breeze-engine-core": "static-1.1410",
  "cms-field-types": "static-1.5279",
  "content-icons-ui": "static-1.2451",
  "integrations-lib": "static-1.17415",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.283",
  "unified-auth-core-lib": "static-1.1515",
  "social-insights-client-types": "static-1.22915",
  "outpost": "static-1.4598",
  "reporting-client-types": "static-1.2828",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11006",
  "immutable-less": "static-1.5121",
  "marketplace-ui-client-types": "static-1.18442",
  "marketplace-ui-common": "static-1.21035",
  "ui-addon-integrations-directory-panel": "static-2.8421",
  "ui-extensibility-client-types": "static-1.4384",
  "growth-data-modal": "static-1.6123",
  "growth-onboarding-next-action-utils": "static-1.2969",
  "onboarding-tours-client": "static-1.5604",
  "ui-shepherd-tracker": "static-1.8126",
  "ui-coaching-tips": "static-1.29576",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1110",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13578",
  "content-media-compositions": "static-2.17585",
  "media-bridge-lib": "static-1.19629",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4895",
  "calling-orchestration-schema": "static-1.37198",
  "crm-record-cards-service-types": "static-1.3870",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16655",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.219",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57352",
  "interframe": "static-3.5209",
  "tinymce-data": "static-1.41467",
  "layout-dnd-components": "static-1.13214",
  "layout-dnd-utils": "static-1.12189",
  "ui-brand-identity-lib": "static-1.16928",
  "academy-common-lib": "static-1.15450",
  "nudge-custom-function-registry": "static-1.3164",
  "nudge-renderer-utils": "static-1.3483",
  "whisper-core-api": "static-1.7622",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14830",
  "integrations-tracking-lib": "static-1.6085",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4606",
  "ai-settings-ui-library": "static-1.8572",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1563",
  "onboarding-data-sync-lib": "static-1.2830",
  "growth-onboarding-next-action-components": "static-1.2997",
  "user-context-client": "static-1.4979",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9365",
  "ContentData": "static-1.69530",
  "layout-data-lib": "static-1.10514",
  "academy-service-client": "static-1.4160",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4863",
  "trellis-ecosystem": "static-1.7837",
  "wootric-nps": "static-1.7295",
  "universal-page-editor-lib": "static-1.3477",
  "settings-ui-lib": "static-1.12997",
  "simple-data-table": "static-1.3806",
  "meetings-connect-utils-lib": "static-1.8086",
  "advanced-menus-core": "static-1.15806",
  "advanced-menus-lib": "static-1.12562",
  "ExportDialog": "static-6.10840",
  "ui-memberships-settings-lib": "static-1.35161",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15805",
  "simple-menus-lib": "static-1.17322"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28690",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2015",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "crm_data": "/crm_data/static-4.93186",
  "data-fetching-client": "/data-fetching-client/static-1.10107",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8737",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1762",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6060",
  "hs-test-utils": "/hs-test-utils/static-1.8505",
  "hub-http": "/hub-http/static-1.6676",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11956",
  "I18n": "/I18n/static-7.1706",
  "jasmine-runner": "/jasmine-runner/static-1.6920",
  "quartz": "/quartz/static-1.7646",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5653",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6093",
  "UIComponents": "/UIComponents/static-3.8902",
  "usage-tracker-public": "/usage-tracker-public/static-1.7601",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38037",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.613",
  "cssUtils": "/cssUtils/static-1.1091",
  "customer-data-objects": "/customer-data-objects/static-1.8168",
  "FireAlarmUi": "/FireAlarmUi/static-1.4856",
  "foundations-assets": "/foundations-assets/static-1.5354",
  "foundations-theming": "/foundations-theming/static-1.4956",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12263",
  "icons": "/icons/static-2.701",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3354",
  "property-translator": "/property-translator/static-1.5847",
  "quartz-config": "/quartz-config/static-1.1424",
  "quartz-core": "/quartz-core/static-1.6865",
  "quartz-i18n": "/quartz-i18n/static-1.1321",
  "quartz-routing": "/quartz-routing/static-1.1076",
  "quartz-tracking": "/quartz-tracking/static-1.1025",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17204",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10838",
  "rpc-client-utils": "/rpc-client-utils/static-1.5139",
  "sanitize-text": "/sanitize-text/static-1.8627",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.517",
  "superstore": "/superstore/static-1.5226",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11615",
  "ui-images": "/ui-images/static-2.1275",
  "usage-tracker-core": "/usage-tracker-core/static-1.7640",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3923",
  "quartz-webpack": "/quartz-webpack/static-1.3870",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.724",
  "bender-build-tools": "/bender-build-tools/static-1.3556",
  "crm_universal": "/crm_universal/static-1.22715",
  "customer-data-email": "/customer-data-email/static-1.18627",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10303",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8389",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8231",
  "quick-fetch": "/quick-fetch/static-1.4228",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5006",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2672",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9892",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3065",
  "ui-fonts": "/ui-fonts/static-1.1218",
  "HeadJS": "/HeadJS/static-2.820",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3616",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.397",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4777",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6220",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5218",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20477",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19551",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11307",
  "crm-message-bus": "/crm-message-bus/static-1.44083",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13501",
  "customer-data-properties": "/customer-data-properties/static-1.53004",
  "growth-payments-core": "/growth-payments-core/static-1.26487",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9542",
  "usage-tracker": "/usage-tracker/static-1.7790",
  "usage-tracker-container": "/usage-tracker-container/static-1.7780",
  "sassPrefix": "/sassPrefix/static-1.356",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4149",
  "foundations-theming-base": "/foundations-theming-base/static-1.3941",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3439",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.259",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.603",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.634",
  "quartz-auth": "/quartz-auth/static-1.1321",
  "quartz-head": "/quartz-head/static-1.1311",
  "quartz-test": "/quartz-test/static-1.1321",
  "trellis-components": "/trellis-components/static-1.3084",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5476",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.169",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.549",
  "chirp-fetch": "/chirp-fetch/static-1.2372",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4942",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5184",
  "sequences-lib": "/sequences-lib/static-1.8758",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5055",
  "FileManagerCore": "/FileManagerCore/static-1.40320",
  "FileManagerLib": "/FileManagerLib/static-1.40461",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5348",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.726",
  "timezone-utils": "/timezone-utils/static-2.5700",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "react-dnd-compat": "/react-dnd-compat/static-1.5079",
  "stylex-utils": "/stylex-utils/static-1.173",
  "trellis-theming": "/trellis-theming/static-1.1465",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2954",
  "hs-resources": "/hs-resources/static-1.664",
  "pulse": "/pulse/static-1.1113",
  "utility-belt": "/utility-belt/static-1.3004",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.2014",
  "customer-data-associations": "/customer-data-associations/static-1.7806",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8516",
  "customer-data-tracking": "/customer-data-tracking/static-1.7340",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7361",
  "framework-data-table": "/framework-data-table/static-2.12829",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50025",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24178",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8232",
  "ui-addon-opt": "/ui-addon-opt/static-4.8869",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10004",
  "customer-data-rte": "/customer-data-rte/static-1.33889",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24821",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3529",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6519",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19264",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15830",
  "payment-link-components": "/payment-link-components/static-1.24440",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5572",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39154",
  "react-colorpicker": "/react-colorpicker/static-2.10677",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18544",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9093",
  "user-context": "/user-context/static-1.5521",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2019",
  "atom": "/atom/static-1.5543",
  "reference-resolvers": "/reference-resolvers/static-1.8649",
  "calling-global-api": "/calling-global-api/static-1.66164",
  "calling-internal-common": "/calling-internal-common/static-1.31796",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67546",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59839",
  "commerce-products-lib": "/commerce-products-lib/static-1.10887",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4110",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4747",
  "crm-links": "/crm-links/static-1.6776",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4440",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10214",
  "external-options-client-types": "/external-options-client-types/static-1.4437",
  "formula-editor": "/formula-editor/static-1.15001",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4517",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1104",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4005",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4278",
  "property-value-citations": "/property-value-citations/static-1.3618",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8575",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.461",
  "smart-property-lib": "/smart-property-lib/static-1.8630",
  "tiered-pricing": "/tiered-pricing/static-1.2237",
  "topics-actions-lib": "/topics-actions-lib/static-1.650",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1374",
  "trial-components-library": "/trial-components-library/static-1.14364",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11346",
  "laboratory-lib": "/laboratory-lib/static-3.7617",
  "onboarding-scopes": "/onboarding-scopes/static-1.6921",
  "seat-types-lib": "/seat-types-lib/static-1.1033",
  "magpie-lib": "/magpie-lib/static-1.5904",
  "navigation-messaging": "/navigation-messaging/static-1.8478",
  "ts-schema": "/ts-schema/static-1.4391",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10887",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10885",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8615",
  "audio-components": "/audio-components/static-1.6558",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.911",
  "ContentUtils": "/ContentUtils/static-1.69455",
  "copilot-toolkit": "/copilot-toolkit/static-1.12130",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30048",
  "FileManagerImages": "/FileManagerImages/static-1.37972",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4610",
  "ui-universal-auth": "/ui-universal-auth/static-1.9719",
  "urlinator": "/urlinator/static-1.4984",
  "video-components": "/video-components/static-1.14418",
  "video-data-lib": "/video-data-lib/static-1.36074",
  "video-embed": "/video-embed/static-1.36908",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.807",
  "trellis-migration-context": "/trellis-migration-context/static-1.47",
  "event-emitter": "/event-emitter/static-1.1431",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.480",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4332",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.616",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7266",
  "persist-promise": "/persist-promise/static-1.4171",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13639",
  "reporting-data": "/reporting-data/static-1.69321",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.420",
  "purchase-motions-components": "/purchase-motions-components/static-1.6620",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7051",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5551",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19567",
  "onboarding-tours": "/onboarding-tours/static-1.17389",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23821",
  "content-assistance-lib": "/content-assistance-lib/static-1.8411",
  "draft-content-plugins": "/draft-content-plugins/static-1.29142",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22344",
  "rich-text-lib": "/rich-text-lib/static-1.20539",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2132",
  "poll-commands": "/poll-commands/static-1.3944",
  "video-components-external": "/video-components-external/static-1.12416",
  "trellis-story-utils": "/trellis-story-utils/static-1.4967",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9996",
  "content-media-capture": "/content-media-capture/static-1.5774",
  "knowledge-content-types": "/knowledge-content-types/static-1.8756",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10333",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9566",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10745",
  "hub-http-contrib": "/hub-http-contrib/static-1.3499",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5671",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6851",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19548",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3991",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18666",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1456",
  "calling-error-reporting": "/calling-error-reporting/static-1.31803",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11509",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7006",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2421",
  "commerce-permissions": "/commerce-permissions/static-1.1255",
  "products-iframe-lib": "/products-iframe-lib/static-1.8895",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11269",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6917",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10970",
  "sales-views-client-types": "/sales-views-client-types/static-1.4724",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10400",
  "bark-lib": "/bark-lib/static-1.16999",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6359",
  "react-codemirror": "/react-codemirror/static-1.11109",
  "data-agent-kit": "/data-agent-kit/static-1.900",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.444",
  "data-agent-utils": "/data-agent-utils/static-1.913",
  "data-token-picker": "/data-token-picker/static-1.17121",
  "fsm": "/fsm/static-1.4227",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7278",
  "react-tinymce": "/react-tinymce/static-1.56256",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11033",
  "tinymce-config": "/tinymce-config/static-2.55382",
  "tinymce-plugins": "/tinymce-plugins/static-1.58496",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15989",
  "hubs-service-types": "/hubs-service-types/static-1.1735",
  "navigation-components": "/navigation-components/static-1.19151",
  "nest": "/nest/static-1.704",
  "nudge-client-utils": "/nudge-client-utils/static-1.3407",
  "purchase-motions-api": "/purchase-motions-api/static-1.6623",
  "signup-constants": "/signup-constants/static-1.19930",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5364",
  "reactive-lib": "/reactive-lib/static-1.1191",
  "simple-logging-lib": "/simple-logging-lib/static-1.3520",
  "nav-meta": "/nav-meta/static-1.30788",
  "breeze-engine-core": "/breeze-engine-core/static-1.1410",
  "cms-field-types": "/cms-field-types/static-1.5279",
  "content-icons-ui": "/content-icons-ui/static-1.2451",
  "integrations-lib": "/integrations-lib/static-1.17415",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.283",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1515",
  "social-insights-client-types": "/social-insights-client-types/static-1.22915",
  "outpost": "/outpost/static-1.4598",
  "reporting-client-types": "/reporting-client-types/static-1.2828",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11006",
  "immutable-less": "/immutable-less/static-1.5121",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18442",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21035",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8421",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4384",
  "growth-data-modal": "/growth-data-modal/static-1.6123",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2969",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5604",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8126",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29576",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1110",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13578",
  "content-media-compositions": "/content-media-compositions/static-2.17585",
  "media-bridge-lib": "/media-bridge-lib/static-1.19629",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4895",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37198",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3870",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16655",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.219",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57352",
  "interframe": "/interframe/static-3.5209",
  "tinymce-data": "/tinymce-data/static-1.41467",
  "layout-dnd-components": "/layout-dnd-components/static-1.13214",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12189",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16928",
  "academy-common-lib": "/academy-common-lib/static-1.15450",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3164",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3483",
  "whisper-core-api": "/whisper-core-api/static-1.7622",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14830",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6085",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4606",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8572",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1563",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2830",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2997",
  "user-context-client": "/user-context-client/static-1.4979",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "ContentData": "/ContentData/static-1.69530",
  "layout-data-lib": "/layout-data-lib/static-1.10514",
  "academy-service-client": "/academy-service-client/static-1.4160",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4863",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7837",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3477",
  "settings-ui-lib": "/settings-ui-lib/static-1.12997",
  "simple-data-table": "/simple-data-table/static-1.3806",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8086",
  "advanced-menus-core": "/advanced-menus-core/static-1.15806",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12562",
  "ExportDialog": "/ExportDialog/static-6.10840",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35161",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15805",
  "simple-menus-lib": "/simple-menus-lib/static-1.17322"
}
};
